import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../Services/api-service';
import { ScanReport, ScanReportResponse, PassbookExcelData, ScanLogExcelData } from '../models/report';
@Component({
  selector: 'app-serial-no-search',
  templateUrl: './serial-no-search.component.html',
  styleUrls: ['./serial-no-search.component.css']
})

export class SerialNoSearchComponent implements OnInit {

  show: boolean = false;
  
  reportExcelPassbook: any[] = [];
  
  fromDtEmpty: boolean = false;
  toDtEmpty: boolean = false;
 
  hoEmpty: boolean = false;
  dealerEmpty: boolean = false;
  siteEmpty: boolean = false;
  formval: ScanReport = new ScanReport();
  totaldata: number;
  siteList: any[] = [];
  availtotaldata: number;
  producttotaldata: number;
  onEdit: boolean = false;
  
  DenominationName: string;
  deleteId: string;
  currentPage: number;
 
  HoUserlist: any[] = [];
  dealerList: any[] = [];
  constructor( private toastr: ToastrService, private modalService: BsModalService, private apiService: ApiService) {
    this.formval.SearchValue = '';    
  }

  ngOnInit() {
    this.setDates();
    this.show = false;
    this.fromDtEmpty = false;
    this.toDtEmpty = false;
    this.hoEmpty = false;
    this.dealerEmpty = false;
   
    // this.getscanreport();
    
  }
  

  setDates(): any {
    var date = new Date();

    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var currentDay = date.getDate();

   
  }


 

  
 debugger;
  getSerialNumberSearch() {
    let obj = {
     // UsrId: this.formval.HOUserId
     search:this.formval.SearchValue,
    }
    this.dealerList = [];
    this.siteList = [];
    // this.formval.AccFrmDDL = null;
    // this.formval.DealerId = null;
    this.apiService.PostApi(obj, "Report/SerialNumberSearch").subscribe((resp: any) => {
      debugger
      if (resp.ResponseCode == 200) {

        this.dealerList = resp.ResponseData[0];
        
      }
      else {
        this.dealerList = [];
      }
    })
  }
 
  
  

}

 




